import { restActionCreatorHelper } from './../../helpers/restActionCreatorHelper';

const storieRestAction = restActionCreatorHelper(`storie`);

export const GetStorieByIdRestActions = storieRestAction('getStorieById');

export const GetStorieListRestActions = storieRestAction('getStorieList');